import { useCallback, useState } from 'react';
import { useOutletContext, useSearchParams } from 'react-router-dom';

import { PlanWizard } from '~/modules/artist-roster/pages/artist-details/pages/media-planner/components/PlanWizard/PlanWizard';
import type { DigitalMediaPlan } from '~/modules/artist-roster/pages/artist-details/pages/media-planner/types';
import type { ArtistDetails } from '~/modules/artist-roster/types';

import { MediaPlan } from './components/MediaPlan/MediaPlan';

export function MediaPlannerPage() {
  // @TODO WMG-819 - Remove showPlan after integration.
  // Put &showPlan=true in the URL to show the plan by default and not have to
  // fill out the data in the wizard. This will be removed once we're done with
  // the wizard and plan integration.
  const [searchParams] = useSearchParams();
  const showPlan = searchParams.get('showPlan') !== null;
  const { artistData } = useOutletContext<{ artistData: ArtistDetails }>();
  const [plan, setPlan] = useState<DigitalMediaPlan | undefined>();

  const handlePlanChange = useCallback((newPlan: DigitalMediaPlan) => {
    setPlan(newPlan);
  }, []);

  /* @TODO WMG-819 - Remove showPlan after integration. */
  return showPlan || plan ? (
    <MediaPlan artistData={artistData} plan={plan} setPlan={setPlan} />
  ) : (
    <PlanWizard
      artistData={artistData}
      onPlanChange={handlePlanChange}
      setPlan={setPlan}
    />
  );
}

MediaPlannerPage.displayName = 'MediaPlannerPage';
